'use client';

import { Typography } from '@/components/ui/Text';
import { cn } from '@/lib/ui/cn';
import { ReactNode } from 'react';
import { IntakePageTextBox } from './IntakePageTextBox';

interface RadioOption {
  value: string;
  label: ReactNode;
}

interface RadioGroupProps {
  name: string;
  options: RadioOption[];
  value: string | undefined;
  onChange: (value: string) => void;
  error?: string;
}

export const IntakeRadioGroup = ({
  name,
  options,
  value,
  onChange,
  error,
}: RadioGroupProps) => (
  <div className='flex flex-col gap-[12px]'>
    {error && (
      <IntakePageTextBox align='center'>
        <Typography variant='body-small' className='mt-1 text-sm text-red-500'>
          {error}
        </Typography>
      </IntakePageTextBox>
    )}

    {options.map(option => (
      <label
        key={option.value}
        className={cn(
          'flex h-[56px] cursor-pointer items-center justify-start gap-[10px] rounded-[60px] border border-[#F1E6D6] bg-white px-[24px] py-[16px] transition-colors',
          value === option.value && 'border-sh-sky bg-sh-sky/5'
        )}
      >
        <input
          type='radio'
          name={name}
          value={option.value}
          checked={value === option.value}
          onChange={e => onChange(e.target.value)}
          className='sr-only'
        />

        <div className='flex h-[24px] w-[24px] flex-shrink-0 items-center justify-center rounded-full border-2 border-[#292722]'>
          {value === option.value && (
            <div className='h-[12px] w-[12px] rounded-full bg-[#292722]' />
          )}
        </div>

        <span className='font-sans text-[15px] leading-[20px] font-normal text-[#292722]'>
          {option.label}
        </span>
      </label>
    ))}
  </div>
);
